// Make the whole shop/archive product card clickable, while letting real
// interactive elements (links, buttons, inputs, quantity selector) behave
// natively. Mouse-only enhancement — keyboard/SR use the real product links.
const productsContainer = document.querySelector<HTMLElement>(
  ".woocommerce.archive #main .products"
);

if (productsContainer) {
  productsContainer.addEventListener("click", (event) => {
    // Plain primary click only — no new-tab/modifier handling by design.
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const target = event.target as HTMLElement;

    const card = target.closest<HTMLElement>("li.product");
    if (!card) {
      return;
    }

    // Let any real interactive element handle its own click.
    if (
      target.closest(
        "a, button, input, select, textarea, label, .njamito_shop_custom_quantity_selector"
      )
    ) {
      return;
    }

    // Don't hijack a text-selection drag.
    if (window.getSelection()?.toString()) {
      return;
    }

    const link = card.querySelector<HTMLAnchorElement>(
      ".woocommerce-loop-product__link"
    );
    if (link?.href) {
      window.location.href = link.href;
    }
  });
}
